module.exports = __webpack_public_path__ + "fonts/RobotoItalic.d6fc5ec5.ttf";